import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Коваленко Андрій',
  role: 'Голова наглядової ради'
}, {
  name: 'Шевченко Олена',
  role: 'Член наглядової ради'
}, {
  name: 'Бондаренко Віктор',
  role: 'Член наглядової ради'
}];
export function SupervisoryBoard() {
  return <FederationMembersPage title="Наглядова рада" subtitle="Контролюючий орган федерації, що забезпечує прозорість діяльності" members={members} data-id="element-783" />;
}